import { HTMLAttributes } from "react";

import { cn } from "../../../lib/utils";

export const Item = ({
  className,
  ...props
}: HTMLAttributes<HTMLDivElement>) => (
  <div
    className={cn(
      "rounded-3xl border border-white/10 bg-slate-900/50 p-4 shadow-sm",
      className
    )}
    {...props}
  />
);
